import React from 'react';
import { Navigate } from 'react-router-dom';
import { paths } from '../../app/paths';
import { Skeleton } from '../../ui';
import { useAuth } from './AuthProvider';

/**
 * Hides admin screens from plain users. This is a convenience only: the server enforces roles (403 for a `user`).
 * While an older session is still asking GET /users/me for its role it waits instead of bouncing the admin away.
 */
export function RequireAdmin({ children }: { children: React.ReactElement }) {
  const { isAdmin, roleLoading } = useAuth();
  if (roleLoading) return <div className="mx-auto max-w-5xl" aria-busy="true"><Skeleton className="h-24 w-full" /></div>;
  if (!isAdmin) return <Navigate to={paths.projects()} replace />;
  return children;
}
